import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const RelationHandlingLevel = ({ handlingLevel, clarification, className, ...rest }) => {
  if (handlingLevel <= 1) return null;

  const tooltip = <Tooltip id="relation-handling-tooltip">{clarification}</Tooltip>;

  return (
    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={tooltip}>
      <i
        className={classNames(
          'fa-fw margin5R fa fa-exclamation-triangle',
          handlingLevel === 2 ? 'text-warning' : 'text-danger',
          className,
        )}
        {...rest}
      />
    </OverlayTrigger>
  );
};

RelationHandlingLevel.propTypes = {
  handlingLevel: PropTypes.number.isRequired,
  clarification: PropTypes.string,
  className: PropTypes.string,
};

RelationHandlingLevel.defaultProps = {
  handlingLevel: 1,
  clarification: '',
  className: undefined,
};

export default React.memo(RelationHandlingLevel);
